export default "__VITE_ASSET__BrRkBfg$__"